module.exports = __webpack_public_path__ + "img/ep-planche-a-decouper.0c649bef.jpg";